@let titleStyle = config.title;
@let dialogTitle = title;
@let hasTitle = !!titleStyle && !!dialogTitle;

<div
  role="dialog"
  cdkTrapFocus
  aria-modal="true"
  class="modal-wrapper"
  data-cy="scope_info_dialog"
  [cdkTrapFocusAutoCapture]="true"
  [attr.aria-labelledby]="hasTitle ? 'scope-info-title' : null"
  [attr.aria-label]="hasTitle ? null : config.ariaLabel"
  [style.backgroundColor]="config.backgroundColor"
>
  @if (titleStyle && dialogTitle) {
    <h2
      class="modal-title"
      id="scope-info-title"
      data-cy="dialog_title"
      [style]="{
        color: titleStyle.color,
        fontFamily: titleStyle.fontFamily,
      }"
    >
      {{ dialogTitle }}
    </h2>
  }

  <!-- Interpolated, never [innerHTML]: this is free text typed into the BO
  "Additional information" field, so it must not be able to inject markup. -->
  <div
    class="modal-body"
    data-cy="scope_info_body"
    [style]="{
      color: config.body.color,
      fontFamily: config.body.fontFamily,
    }"
  >
    {{ body }}
  </div>

  <div class="modal-footer justify-content-center mt-3">
    <b2c-button
      class="close-btn"
      data-cy="close_btn"
      (click)="closeDialog()"
      [styles]="{
        color: closeButtonConfig.textColor,
        borderRadius: closeButtonConfig.borderRadius,
        backgroundColor: closeButtonConfig.backgroundColor,
        borderColor:
          closeButtonConfig.borderColor || closeButtonConfig.backgroundColor,
      }"
    >
      {{ closeButtonConfig.label }}</b2c-button
    >
  </div>
</div>
